import { ComponentType, lazy, LazyExoticComponent, Suspense } from 'react';

import { useAppStore, type IAppStore } from '@/store';
import { Screen } from '@/types';
import useStyles from './styles';

import MobileCreate from '@/components/MobileCreate';

const Loading = lazy(() => import('@/components/Loading'));
const Generations = lazy(() => import('@/components/Generations'));
const CategoryRowsHome = lazy(() => import('@/components/CategoryRowsHome'));

const selector = (store: IAppStore) => ({ screen: store.screen });

const overlayComponents: Partial<
  Record<Screen, LazyExoticComponent<ComponentType> | ComponentType>
> = {
  [Screen.Loading]: Loading,
  [Screen.Files]: Generations,
  [Screen.Library]: CategoryRowsHome,
};

const MobileLayout = () => {
  const { screen } = useAppStore(selector);
  const classes = useStyles();

  if (screen === Screen.Create) {
    return (
      <div className={classes.mobileContent}>
        <div className={classes.screenLayer}>
          <MobileCreate />
        </div>
      </div>
    );
  }

  const Overlay = overlayComponents[screen];

  if (!Overlay) return null;

  return (
    <div className={classes.mobileContent}>
      <div className={classes.screenLayer}>
        <Suspense fallback={null}>
          <Overlay />
        </Suspense>
      </div>
    </div>
  );
};

export default MobileLayout;
